import { DriverV2Output } from '@allocab/allocab-driver-service-types';
import { SubscribeByFleetManagerInput } from '@allocab/allocab-driver-shared-types';
import { useMutation } from '@tanstack/react-query';

import { queryKeys } from '../services/datastore/queryKeys';
import { queryClient } from '../services/datastore/react-query';
import { driverApi } from '../services/network/Api';

const createDriver = (input: SubscribeByFleetManagerInput) =>
  driverApi.post<SubscribeByFleetManagerInput, DriverV2Output>('/v1/driver', input);

export const useCreateDriver = () =>
  useMutation<DriverV2Output, unknown, SubscribeByFleetManagerInput>({
    mutationFn: createDriver,
    onSuccess: driver => {
      queryClient.setQueryData(queryKeys.user.fetchDriver(driver.id), driver);
      queryClient.invalidateQueries(queryKeys.user.fetchDrivers());
    },
  });
